import React from "react";
import { useTranslation } from "react-i18next";
import { TableCell as MuiTableCell, TableCellProps as MuiTableCellProps } from "@mui/material";

export interface TableCellProps extends MuiTableCellProps {
    text?: string | null | undefined;
    tx?: string;
    txOptions?: object;
}

export const TableCell = (props: TableCellProps) => {
    const { tx, txOptions, text, children, ...rest } = props;

    const { t } = useTranslation();

    // @ts-expect-error tx err
    const translated = tx && t(tx, txOptions);
    const content = translated || text || children;

    return <MuiTableCell {...rest}>{content}</MuiTableCell>;
};
